/**
 * use-is-mobile.ts — màn hình điện thoại (< 768px = breakpoint `md` của Tailwind).
 * Dùng cho bố cục khác hẳn giữa điện thoại và máy tính (khung ứng dụng, Hộp thư); chỉ đổi kích cỡ thì dùng lớp `md:`.
 */
import { useSyncExternalStore } from 'react'

export const MOBILE_QUERY = '(max-width: 767px)'

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

function subscribe(onChange: () => void) {
  if (!canMatch()) return () => {}
  const mq = window.matchMedia(MOBILE_QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

const snapshot = () => (canMatch() ? window.matchMedia(MOBILE_QUERY).matches : false)

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false)
}
